import PageHeader from "../components/page-header"
import analyticsInsta from "../assets/img/analytics-insta.svg"
import desktopIcon from "../assets/img/desktop-icon.svg";
import mobileIcon from "../assets/img/mobile-icon.svg";
import tabletIcon from "../assets/img/tablet-icon.svg";
import analyticsUp from "../assets/img/analytics-up.svg"
import analyticsDown from "../assets/img/analytics-down.svg"
import menuOverview from "../assets/img/menu-overview.svg"
import safariIcon from "../assets/img/safari-icon.svg"
import chromeIcon from "../assets/img/chrome-icon.svg"
import edgeIcon from "../assets/img/edge-icon.svg"
import chevron_down from "../assets/img/modals/chevron-down.svg"
import 'bootstrap/dist/js/bootstrap.bundle.min';
import "../assets/css/analytics.css"
import "../assets/calendar-plugin/css/mobiscroll.jquery.min.css"
import { useEffect, useRef, useState } from "react"
import { Line } from 'react-chartjs-2';
import Skeleton from "react-loading-skeleton"
import { months, originalOptions, originalData } from "../utils/analytics/line";
import "../assets/calendar-plugin/js/mobiscroll.jquery.min.js"
import infoIcon from "../assets/img/info-black.svg"
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Filler,    
} from 'chart.js';
import * as $ from "jquery";
import { hideLoader, showLoader } from "../components/loader"
import { apiUrl } from "../utils/url"
import { audiencePosts as statGets } from "../services/postRequests/audience"
import setDateFormat from "../utils/setDateFormat"
import { useDispatch, useSelector } from "react-redux";
import CommunityFooter from "../components/community/footer"
import Teammoadal from "../components/teammember/team_modal";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import NewSideBar from "../components/side-bar/new-sidebar";
import AnalyticsSession from "./analytics-session.jsx";
import CustomTooltip from "../components/common/CustomTooltip.jsx";
// import * as flags from "../assets/img/flags"

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Filler,
);

let apiBasePath = "/project/statistics"

var today = new Date();
var today_text = months[today.getMonth()] + ' ' + today.getDate();

var week_before = new Date();
week_before.setDate(week_before.getDate() - 7);
var week_before_text = months[week_before.getMonth()] + ' ' + week_before.getDate();
var first_date, first_date_text = '', last_date, last_date_text = '';

let graph_dates = new Date();
var labels = []

for (let index = 1; index < 10; index++) {
    graph_dates.setDate(graph_dates.getDate() - 1);
    labels.push(months[graph_dates.getMonth()] + ' ' + graph_dates.getDate());
}

const flagsPath = ""
let params = [];
let queryParams = []
export const calculateDateRange = (filterValue) => {
    const now = new Date();
    let from_date, to_date;

    switch (filterValue) {
        case '24h':
            from_date = new Date(now.getTime() - 24 * 60 * 60 * 1000);
            break;
        case '48h':
            from_date = new Date(now.getTime() - 48 * 60 * 60 * 1000);
            break;
        case '7d':
            from_date = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
            break;
        case '30d':
            from_date = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
            break;
        case 'all':
            from_date = new Date(0); // Starting date to cover all time
            break;
        default:
            return null;
    }
    to_date = now;
    return { from_date, to_date };
};
const Analytics = () => {
    const dateFilters = [
        { label: 'Last 24 hrs', value: '24h' },
        { label: 'Last 48 hrs', value: '48h' },
        { label: 'Last 7 days', value: '7d' },
        { label: 'Last 30 days', value: '30d' },
        // { label: 'All Time', value: 'all' }
    ];
    const [loading, setloading] = useState(true);
    const [statsloading, setStatsloading] = useState(true);
    const history = useHistory()
    const [screenWidth, setscreenWidth] = useState(false)
    const { basePath, slug } = useSelector(state => state?.slugReducer);
    const [topSources, settopSources] = useState(null)
    const [topCountries, settopCountries] = useState(null)
    const [devices, setdevices] = useState({})
    const [browsers, setbrowsers] = useState({})
    const [languages, setlanguages] = useState({})
    const [activity, setactivity] = useState({})
    const secondPg = useRef(null);
    const [showModalasd, setShowModalasd] = useState(false)
    const pro = useSelector(state => state?.proReducer);
    const newUser = useSelector(state => state?.newUserReducer);
    const planType = useSelector(state => state?.planTypeReducer);
    const dispatch = useDispatch();
    const campaignsList = useSelector(state => state?.campgignsListReducer);
    const [filter, setfilter] = useState({
        page: 1,
    })
    const [campaign_id, setCampaignId] = useState("all")
    const [selectedCampaignName, setSelectedCampaignName] = useState("All"); // Default name
    const [statsData, setstatsData] = useState({
        unique_visitors: {},
        impressions: {},
        click_rate: {},
        time_on_page: {},
    })
    const [selectedFilter, setSelectedFilter] = useState('All');
    const [isCustomOpen, setIsCustomOpen] = useState(false);
    const [tab, setTab] = useState('overview');
    const [graphData, setgraphdata] = useState({
        unique_visitors: {
            label: 'Unique Visitors',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            fill: true,
            borderColor: '#0C8CFB',
            backgroundColor: 'rgba(12, 140, 251, 0.1)',
            tension: 0.1,
            pointBackgroundColor: '#0C8CFB',
            pointBorderColor: '#0C8CFB',
            borderWidth: 2.8,
            
        },
        impressions: {
            label: 'Impressions Visitors',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            fill: true,
            borderColor: '#7F48FB',
            backgroundColor: 'rgba(127, 72, 251, 0.1)',
            tension: 0.1,
            pointBackgroundColor: '#7F48FB',
            pointBorderColor: '#7F48FB',
            borderWidth: 2.8,
            
        },
        click_rate: {
            label: 'Click Rate',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            fill: true,
            borderColor: '#FB48C9',
            backgroundColor: 'rgba(251, 72, 201, 0.1)',
            tension: 0.1,
            pointBackgroundColor: '#FB48C9',
            pointBorderColor: '#FB48C9',
            borderWidth: 2.8,
            
        },
        time_on_page: {
            label: 'Time on Page',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            fill: true,
            borderColor: '#FB9E48',
            backgroundColor: 'rgba(251, 158, 72, 0.1)',
            tension: 0.1,
            pointBackgroundColor: '#FB9E48',
            pointBorderColor: '#FB9E48',
            borderWidth: 2.8,
            
        },
        // pages_scrolled: {
        //     label: 'Pages Scrolled',
        //     data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        //     fill: true,
        //     borderColor: '#ff0000',
        //     backgroundColor: 'rgba(251, 0, 0, 0.1)',
        //     tension: 0.1,
        //     pointBackgroundColor: '#ff0000',
        //     pointBorderColor: '#ff0000',
        //     borderWidth: 2.8,
        // }
    })
    const [date, setDate] = useState({});
    // useEffect(() => {
    //     setShowModalasd(!pro);
    // }, [pro]);

    const [data, setData] = useState({
        loaded: false,
        labels: labels,
        datasets: [
            {
                label: 'Unique Visitors',
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                fill: true,
                borderColor: '#0C8CFB',
                backgroundColor: 'rgba(12, 140, 251, 0.1)',
                tension: 0.1,
                pointBackgroundColor: '#0C8CFB',
                pointBorderColor: '#0C8CFB',
                borderWidth: 2.8,
                
            },
            {
                label: 'Impressions Visitors',
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                fill: true,
                borderColor: '#7F48FB',
                backgroundColor: 'rgba(127, 72, 251, 0.1)',
                tension: 0.1,
                pointBackgroundColor: '#7F48FB',
                pointBorderColor: '#7F48FB',
                borderWidth: 2.8,
                
            },
            {
                label: 'Click Rate',
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                fill: true,
                borderColor: '#FB48C9',
                backgroundColor: 'rgba(251, 72, 201, 0.1)',
                tension: 0.1,
                pointBackgroundColor: '#FB48C9',
                pointBorderColor: '#FB48C9',
                borderWidth: 2.8,
                
            },
            {
                label: 'Time on Page',
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                fill: true,
                borderColor: '#FB9E48',
                backgroundColor: 'rgba(251, 158, 72, 0.1)',
                tension: 0.1,
                pointBackgroundColor: '#FB9E48',
                pointBorderColor: '#FB9E48',
                borderWidth: 2.8,
                
            },
            // {
            //     label: 'Pages Scrolled',
            //     data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            //     fill: true,
            //     borderColor: '#ff0000',
            //     backgroundColor: 'rgba(251, 0, 0, 0.1)',
            //     tension: 0.1,
            //     pointBackgroundColor: '#ff0000',
            //     pointBorderColor: '#ff0000',
            //     borderWidth: 2.8,
                
            // }
        ]
    })

    const callActivity = (_filter) => {
        showLoader()
        params = [];
        for (const key in _filter) {
            if (Object.hasOwnProperty.call(_filter, key)) {
                if (_filter[key])
                    params.push(`${[key]}=${_filter[key]}`)
            }
        };
        if (pro) {
            if (_filter?.page) {
                const formdata = new FormData();
                var myHeaders = new Headers();
                myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
                const setOptions = {
                    method: "GET",
                    headers: myHeaders,
                }
                statGets(apiUrl + apiBasePath + "/getActivityLog/" + localStorage.slug + queryParams + "&" + params?.join("&"), hideLoader, setOptions).then((response) => setactivity(response)).catch((err) => console.error(err))
            }
        }
    }

    useEffect(() => {
        if (window.screen.width < 454) {
            setscreenWidth(true)
        }
        setTimeout(() => {
            setloading(false)
            // renderCalendar();
        }, 1500);

    }, []);

    const getStats = (from_date, to_date, product_id = "all") => {
        // setloading(true)
        // queryParams = []
        // queryParams = "?from_date=" + from_date + "&to_date=" + to_date;
        // if (product_id !== "all") {
        //     queryParams += `&product_id=${product_id}`;
        // }
        setStatsloading(true);
        let queryParams = `?from_date=${from_date}&to_date=${to_date}`;
        if (product_id !== "all") queryParams += `&product_id=${product_id}`;
        for (const key in filter) {
            if (Object.hasOwnProperty.call(filter, key)) {
                if (filter[key])
                    queryParams += `&${key}=${filter[key]}`;
            }
        };
        setDate({from_date:from_date,to_date:to_date})
        // const formdata = new FormData();
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        const setOptions = {
            method: "GET",
            headers: myHeaders,
        }
        let temp_graph_data = []
        statGets(apiUrl + apiBasePath + "/get/" + slug + params + queryParams, hideLoader, setOptions).then((response) => {
            setstatsData({ ...response })

            temp_graph_data.push(
                {
                    label: 'Unique Visitors',
                    fill: true,
                    borderColor: '#0C8CFB',
                    backgroundColor: 'rgba(12, 140, 251, 0.1)',
                    tension: 0.1,
                    pointBackgroundColor: '#0C8CFB',
                    pointBorderColor: '#0C8CFB',
                    borderWidth: 2.8,
                    
                    data: response?.graph_data?.unique_visitors
                },
                {
                    label: 'Total Views',
                    fill: true,
                    borderColor: '#7F48FB',
                    backgroundColor: 'rgba(127, 72, 251, 0.1)',
                    tension: 0.1,
                    pointBackgroundColor: '#7F48FB',
                    pointBorderColor: '#7F48FB',
                    borderWidth: 2.8,
                    
                    data: response?.graph_data?.impressions,
                },
                {
                    label: 'Click Rate',
                    fill: true,
                    borderColor: '#FB48C9',
                    backgroundColor: 'rgba(251, 72, 201, 0.1)',
                    tension: 0.1,
                    pointBackgroundColor: '#FB48C9',
                    pointBorderColor: '#FB48C9',
                    borderWidth: 2.8,
                    
                    data: response?.graph_data?.click_rate,
                },
                {
                    label: 'Time on Page',
                    fill: true,
                    borderColor: '#FB9E48',
                    backgroundColor: 'rgba(251, 158, 72, 0.1)',
                    tension: 0.1,
                    pointBackgroundColor: '#FB9E48',
                    pointBorderColor: '#FB9E48',
                    borderWidth: 2.8,
                    
                    data: response?.graph_data?.time_on_page,
                },
                // {
                //     label: 'Pages Scrolled',
                //     fill: true,
                //     borderColor: '#ff0000',
                //     backgroundColor: 'rgba(251, 0, 0, 0.1)',
                //     tension: 0.1,
                //     pointBackgroundColor: '#ff0000',
                //     pointBorderColor: '#ff0000',
                //     borderWidth: 2.8,
                //     data: response?.graph_data?.pages_scrolled,

                // }
            );

            setData({ labels: response?.graph_data?.labels, datasets: temp_graph_data });

            setgraphdata({
                unique_visitors: {
                    label: 'Unique Visitors',
                    data: response?.graph_data?.unique_visitors,
                    fill: true,
                    borderColor: '#0C8CFB',
                    backgroundColor: 'rgba(12, 140, 251, 0.1)',
                    tension: 0.1,
                    pointBackgroundColor: '#0C8CFB',
                    pointBorderColor: '#0C8CFB',
                    borderWidth: 2.8,
                    
                },
                impressions: {
                    label: 'Impressions Visitors',
                    data: response?.graph_data?.impressions,
                    fill: true,
                    borderColor: '#7F48FB',
                    backgroundColor: 'rgba(127, 72, 251, 0.1)',
                    tension: 0.1,
                    pointBackgroundColor: '#7F48FB',
                    pointBorderColor: '#7F48FB',
                    borderWidth: 2.8,
                    
                },
                click_rate: {
                    label: 'Click Rate',
                    data: response?.graph_data?.click_rate,
                    fill: true,
                    borderColor: '#FB48C9',
                    backgroundColor: 'rgba(251, 72, 201, 0.1)',
                    tension: 0.1,
                    pointBackgroundColor: '#FB48C9',
                    pointBorderColor: '#FB48C9',
                    borderWidth: 2.8,
                    
                },
                time_on_page: {
                    label: 'Time on Page',
                    data: response?.graph_data?.time_on_page,
                    fill: true,
                    borderColor: '#FB9E48',
                    backgroundColor: 'rgba(251, 158, 72, 0.1)',
                    tension: 0.1,
                    pointBackgroundColor: '#FB9E48',
                    pointBorderColor: '#FB9E48',
                    borderWidth: 2.8,
                    
                },
                // pages_scrolled: {
                //     label: 'Pages Scrolled',
                //     data: response?.graph_data?.pages_scrolled,
                //     fill: true,
                //     borderColor: '#ff0000',
                //     backgroundColor: 'rgba(251, 0, 0, 0.1)',
                //     tension: 0.1,
                //     pointBackgroundColor: '#ff0000',
                //     pointBorderColor: '#ff0000',
                //     borderWidth: 2.8,

                // }
                
            });

            // statGets(apiUrl + apiBasePath + "/getDetailed/" + slug + queryParams, hideLoader, setOptions).then((response) => {
                settopSources(response?.top_sources)
                settopCountries(response?.top_countries);
                setdevices(response?.devices)
                setlanguages(response?.languages)
                setbrowsers(response?.browsers)
                // setactivity(response?.more_details)
                setStatsloading(false);
                // statGets(apiUrl + apiBasePath + "/getActivityLog/" + slug + queryParams, hideLoader, setOptions).then((response) => {
                //     setactivity(response)
                // }).catch((err) => console.error(err))
                // settopSources()
                // setloading(false)
            // }).catch((err) => console.error(err))
            // setloading(false)
        })
    }

    const renderCalendar = () => {
        var myCalendar = $('#calendar-picker').mobiscroll().datepicker({
            controls: ['calendar'],
            display: 'inline',
            calendarSize: 1,
            selectMultiple: true,
            selectMin: 1,
            selectMax: 2,
            returnFormat: 'locale',
            themeVariant: 'light',
            theme: 'ios',
            max: new Date(),
            onChange: function (event, inst) {
                if (event.value[0]) {
                    first_date = new Date(event.value[0]);
                    first_date_text = months[first_date.getMonth()] + ' ' + first_date.getDate();
                }
                if (event.value[1]) {
                    last_date = new Date(event.value[1]);
                    last_date_text = months[last_date.getMonth()] + ' ' + last_date.getDate();
                }
                if (first_date > last_date) {
                    first_date = event.value[1];
                    last_date = event.value[0];
                    $(".date-filter-dropdown-menu-selected").text(last_date_text + ' - ' + first_date_text);
                }
                else {
                    $(".date-filter-dropdown-menu-selected").text(first_date_text + ' - ' + last_date_text);
                }
                if (event.value[0] && event.value[1]) {
                    getStats(setDateFormat(first_date, false, true), setDateFormat(last_date, false, true))
                }
            }
        }).mobiscroll('getInst');

        // alert(today);
        setTimeout(() => {
            myCalendar?.setVal([week_before, today]);
        }, 1500);
    }

    useEffect(() => {
        // mobiscroll.setOptions({
        //     theme: 'ios',
        //     themeVariant: 'light'
        // });
        if (!loading) {

            $('.date-filter-dropdown-menu').on('click', function (e) {
                e.stopPropagation();
            });
            $(".date-filter-dropdown-menu-selected").text(week_before_text + ' - ' + today_text);
            renderCalendar();

        }
    }, [loading, filter])

    useEffect(() => {
        regenerateGraph();
    }, [graphData])

    function regenerateGraph() {
        let tempArr = []
        for (let index = 0; index < 4; index++) {
            if ($('input[name="analytics-graph-filter[]"]').eq(index).is(':checked')) {
                var checked_value = $('input[name="analytics-graph-filter[]"]').eq(index).val();
                tempArr.push(graphData[checked_value]);

            }
        }
        setData({
            labels: data?.labels,
            datasets: tempArr
        });

    }
    const analyticsGraphFilterClick = () => {
        // showLoader();
        if ($('input[name="analytics-graph-filter[]"]:checked').length == 4) {
            $(".filter-dropdown-menu-selected").text('All');
        }
        else if ($('input[name="analytics-graph-filter[]"]:checked').length > 0) {
            $(".filter-dropdown-menu-selected").text('Applied');
        }
        else {
            $(".filter-dropdown-menu-selected").text('None');
        }
        regenerateGraph();
    }

    const upgradeHandleClick = (e) => {
        e.preventDefault();
        // $(".upgrade-main-btn").click();
        if (newUser == 1) {
            history.push(basePath + '/settings/upgrade-zaap')
        } else {
            dispatch({ type: "SET_UPGRADE_MODAL", payload: { isPro: false, open: true } });
        }
        // setShowModalasd(false);
    }
    const handleCheckboxChange = (productId, name) => {
        // Select the checkbox element
        const checkbox = document.getElementById(`graph-label-${productId}`);
        // Call getStats with the selected product ID
        if (checkbox?.checked) {
            setCampaignId(productId);
            setSelectedCampaignName(name);
            getStats(setDateFormat(first_date, false, true), setDateFormat(last_date, false, true), productId);
        } else {
            // Call getStats with "all" or whatever logic you need
            setCampaignId("all");
            setSelectedCampaignName('All');
            getStats(setDateFormat(first_date, false, true), setDateFormat(last_date, false, true), "all");
        }
    };
    const handleFilterSelect = (filter, value) => {
        if (value === 'custom') {
            setIsCustomOpen((prev) => !prev);
        } else {
            setIsCustomOpen(false);
            if (value) {
                const { from_date, to_date } = calculateDateRange(value);
                getStats(from_date.toISOString(), to_date.toISOString(), campaign_id);
                setSelectedFilter(filter);
            }
        }
    };
    function toggleTab(e) {
        const selectedValue = e.target.value;
        setTab(selectedValue);
    }
    return (
        <>
            <div id="wrapper">
                <PageHeader />
                <div className="analytics-main">
                    <NewSideBar from={"analytics"} />
                    {/* <div className="left-side-bar d-flex align-items-center flex-column justify-content-start">
                        <a href="" className="left-menu-item active">
                            <img src={menuOverview} width="20px" alt="" />
                            <p className="mb-0 ms-2">Overview</p>
                        </a>
                    </div> */}


                    <section className="analytics-section">
                        {showModalasd && <Teammoadal showModal={showModalasd} upgradeHandleClick={upgradeHandleClick} heading={'Upgrade to Unlock Analytics.'} text={' Analytics is a PRO only Feature, Subscribe to<br /> PRO to unlock Analytics'} isUltra={false} />}
                        <div className="d-flex justify-content-between align-items-center">

                            <div>
                                <div className="mb-0 page-heading">Analytics</div>
                                <div className="page-description mt-10px">Gain detailed insights about your Lead pages.</div>
                            </div>
                            <div className="d-flex flex-column align-items-end">
                                <div class="toggle-input-checkbox analytics-toggle">
                                    <input type="radio" id="text_align_left" name="planType" onChange={toggleTab} checked={tab == "overview"} style={{ display: "none" }} value={"overview"} />
                                    <label for="text_align_left" className='w-50' > <span > Overview</span></label>
                                    <input type="radio" id="text_align_right" name="planType" onChange={toggleTab} checked={tab == "sessions"} style={{ display: "none" }} value={"sessions"} />
                                    <label for="text_align_right" className='w-50' > Sessions </label>
                                </div>
                                <div className="d-flex align-items-center justify-content-end analytics-filter-main mt-20px gap-1">
                                    <div className="filter-dropdown date-filter-dropdown dropdown-toggle noselect me-1" id="filter-dropdown"
                                        data-bs-toggle="dropdown" aria-expanded="false">
                                        <span className="">Campaign:</span>
                                        <span className="filter-dropdown-menu-selected ms-2 font-weight-500">{selectedCampaignName}</span>
                                        <img src={chevron_down} width="10px" alt="" className="ms-1" />
                                    </div>

                                    <ul className="dropdown-menu filter-dropdown-menu analytics-filter-dropdown-menu"
                                        aria-labelledby="filter-dropdown" onClick={e => e.stopPropagation()}>
                                        <li>
                                            <a className="dropdown-item active" href="#" data-value="All">
                                                <span className="me-5 d-flex align-items-center justify-content-betwen">
                                                    <input type="checkbox" value="all" name="selected-campaign" id="all-campaign" checked={campaign_id == 'all'} onClick={handleCheckboxChange.bind(null, "all")} />
                                                    <label htmlFor="all-campaign">All</label>
                                                </span>
                                            </a>
                                        </li>
                                        {campaignsList?.length > 0 && campaignsList?.map((val, index) =>
                                            <li key={index}>
                                                <a className="dropdown-item active" href="#" data-value={val?.name}>
                                                    <span className="me-5 d-flex align-items-center justify-content-betwen">
                                                        <input type="checkbox" value={val?.id} name="selected-campaign" id={`graph-label-${val.id}`}
                                                            checked={val?.id == campaign_id}
                                                            onClick={() => handleCheckboxChange(val?.id, val?.name)} />
                                                        <label htmlFor={`graph-label-${val.id}`}>{val?.name}</label>
                                                    </span>
                                                </a>
                                            </li>
                                        )}
                                    </ul>
                                    <div className="filter-dropdown date-filter-dropdown dropdown-toggle noselect" id="filter-dropdown"
                                        data-bs-toggle="dropdown" aria-expanded="false">
                                        <span className="">Filter:</span>
                                        <span className="filter-dropdown-menu-selected ms-2 font-weight-500">All</span>
                                        <img src={chevron_down} width="10px" alt="" className="ms-1" />
                                    </div>

                                    <ul className="dropdown-menu filter-dropdown-menu analytics-filter-dropdown-menu"
                                        aria-labelledby="filter-dropdown" onClick={e => e.stopPropagation()}>
                                        <li>
                                            <a className="dropdown-item active" href="#" data-value="All">
                                                <span className="me-5 d-flex align-items-center justify-content-betwen">
                                                    <input type="checkbox" value="unique_visitors" name="analytics-graph-filter[]" id="graph-label-1" defaultChecked={true} onClick={analyticsGraphFilterClick} />
                                                    <label htmlFor="graph-label-1" className="unique_visitors">Unique Visitors</label>
                                                </span>
                                                {/* <small className="text-muted">{statsData?.unique_visitors?.count}</small> */}
                                            </a>
                                        </li>

                                        <li>
                                            <a className="dropdown-item active" href="#" data-value="All">
                                                <span className="me-5 d-flex align-items-center justify-content-betwen">
                                                    <input type="checkbox" value="impressions" name="analytics-graph-filter[]" id="graph-label-2" defaultChecked={true} onClick={analyticsGraphFilterClick} />
                                                    <label htmlFor="graph-label-2" className="impressions">Total Views</label>
                                                </span>
                                                {/* <small className="text-muted">{statsData?.impressions?.count}</small> */}
                                            </a>
                                        </li>

                                        <li>
                                            <a className="dropdown-item active" href="#" data-value="All">
                                                <span className="me-5 d-flex align-items-center justify-content-betwen">
                                                    <input type="checkbox" value="click_rate" name="analytics-graph-filter[]" id="graph-label-3" defaultChecked={true} onClick={analyticsGraphFilterClick} />
                                                    <label htmlFor="graph-label-3" className="click_rate">Click Rate</label>
                                                </span>
                                                {/* <small className="text-muted">{statsData?.click_rate?.count}</small> */}
                                            </a>
                                        </li>


                                        <li>
                                            <a className="dropdown-item active" href="#" data-value="All">
                                                <span className="me-5 d-flex align-items-center justify-content-betwen">
                                                    <input type="checkbox" value="time_on_page" name="analytics-graph-filter[]" id="graph-label-4" defaultChecked={true} onClick={analyticsGraphFilterClick} />
                                                    <label htmlFor="graph-label-4" className="time_on_page">Time on Page</label>
                                                </span>
                                                {/* <small className="text-muted">${statsData?.time_on_page?.count}</small> */}
                                            </a>
                                        </li>

                                        {/* <li>
                                            <a className="dropdown-item active" href="#" data-value="All">
                                                <span className="me-5 d-flex align-items-center justify-content-betwen">
                                                    <input type="checkbox" value="pages_scrolled" name="analytics-graph-filter[]" id="graph-label-5" defaultChecked={true} onClick={analyticsGraphFilterClick} />
                                                    <label htmlFor="graph-label-5">Page Scrolled</label>
                                                </span>
                                            </a>
                                        </li> */}

                                    </ul>

                                    <div className="ms-1 date-filter-dropdown dropdown-toggle noselect"
                                        id="date-filter-dropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                        <span className="date-filter-dropdown-menu-selected font-weight-500">{selectedFilter}</span>
                                        <img src={chevron_down} width="10px" alt="" className="ms-1" />
                                    </div>

                                    <ul className="dropdown-menu overflow-visible mh-100">
                                        {dateFilters && dateFilters?.map((filter, index) => (
                                            <li key={index} onClick={() => handleFilterSelect(filter.label, filter?.value)}>
                                                <div className="filter-dropdown-item" >{filter?.label}</div>
                                            </li>
                                        ))}
                                        <li key={dateFilters?.length} onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            handleFilterSelect(null, 'custom')
                                        }}>
                                            <div className="filter-dropdown-item noselect"
                                                id="custom-date-filter-dropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                                <span className="font-weight-500">Custom Range</span>
                                            </div>
                                            <ul className="dropdown-menu" aria-labelledby="custom-date-filter-dropdown" onClick={e => e.stopPropagation()}>
                                                <li>
                                                    <div id="calendar-picker"></div>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>

                                </div>
                            </div>
                        </div>

                        {tab == 'overview' ?
                            <div className="section-main mt-4">
                                <div className="analytics-sections" style={{ maxHeight: "100%" }}>
                                    <div className="d-flex align-items-end justify-content-between analytics-header">

                                        <div className="search-bar d-flex align-items-center jusitfy-content-start flex-wrap">
                                            <div className="analytics-card analytics-card-blue me-0">
                                                <div className="d-flex align-items-center gap-1">
                                                    <div className="analytics-box"></div>
                                                    <div className="analytics-type-heading">Unique Visitors</div>
                                                </div>
                                                {statsData?.unique_visitors?.type ? (
                                                    <div className="d-flex align-items-center justify-content-start">
                                                        <span className="analytics-count mb-1 me-1">{statsData?.unique_visitors?.count}</span>
                                                        <span
                                                            className={`analytics-badge ${statsData?.unique_visitors?.type === "up" ? 'analytics-badge-success' : 'analytics-badge-danger'} d-flex align-items-center justify-content-center`}
                                                        >
                                                            {statsData?.unique_visitors?.type !== "-" && (
                                                                <img src={statsData?.unique_visitors?.type === "up" ? analyticsUp : analyticsDown} width="10px" alt="" />
                                                            )}
                                                            <span className="ms-1">{statsData?.unique_visitors?.progress === "-" ? 0 : statsData?.unique_visitors?.progress}%</span>
                                                        </span>
                                                    </div>
                                                ) : (
                                                    <div className="d-flex align-items-center justify-content-end">
                                                        <h1 className="mb-1 me-2">
                                                            <Skeleton width={50} height={40} className="mb-2" highlightColor="#0C8CFB" borderRadius="0.5rem" duration={4} />
                                                        </h1>
                                                        <span className="d-flex align-items-center justify-content-center">
                                                            <Skeleton width={40} height={15} className="mb-2" baseColor="#D5F5E3" highlightColor="#0CBD5B" duration={4} borderRadius="5px" />
                                                        </span>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="analytics-card analytics-card-purple me-0">
                                                <div className="d-flex align-items-center gap-1">
                                                    <div className="analytics-box"></div>
                                                    <div className="analytics-type-heading">Total Views</div>
                                                </div>
                                                {statsData?.impressions?.type ? (
                                                    <div className="d-flex align-items-center justify-content-start">
                                                        <span className="analytics-count mb-1 me-1">{statsData?.impressions?.count}</span>
                                                        <span
                                                            className={`analytics-badge ${statsData?.impressions?.type === "up" ? 'analytics-badge-success' : 'analytics-badge-danger'} d-flex align-items-center justify-content-center`}>
                                                            {statsData?.impressions?.type !== "-" && (
                                                                <img src={statsData?.impressions?.type === "up" ? analyticsUp : analyticsDown} width="10px" alt="" />
                                                            )}
                                                            <span className="ms-1">{statsData?.impressions?.progress === "-" ? 0 : statsData?.impressions?.progress}%</span>
                                                        </span>
                                                    </div>
                                                ) : (
                                                    <div className="d-flex align-items-center justify-content-start">
                                                        <h1 className="mb-1 me-2">
                                                            <Skeleton width={50} height={40} className="mb-2" highlightColor="#7F48FB" borderRadius="0.5rem" duration={4} />
                                                        </h1>
                                                        <span className="d-flex align-items-center justify-content-center">
                                                            <Skeleton width={40} height={15} className="mb-2" baseColor="#FCD9DB" highlightColor="#EA1320" duration={4} borderRadius="5px" />
                                                        </span>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="analytics-card analytics-card-pink me-0">
                                                <div className="d-flex align-items-center gap-1">
                                                    <div className="analytics-box"></div>
                                                    <div className="analytics-type-heading">Click Rate</div>
                                                </div>
                                                {statsData?.click_rate?.type ? (
                                                    <div className="d-flex align-items-center justify-content-start">
                                                        <div className="analytics-count mb-1 me-1">{statsData?.click_rate?.count}%</div>
                                                        <span
                                                            className={`analytics-badge ${statsData?.click_rate?.type === "up" ? 'analytics-badge-success' : 'analytics-badge-danger'} d-flex align-items-center justify-content-center`}
                                                        >
                                                            {statsData?.click_rate?.type !== "-" && (
                                                                <img src={statsData?.click_rate?.type === "up" ? analyticsUp : analyticsDown} width="10px" alt="" />
                                                            )}
                                                            <span className="ms-1">{statsData?.click_rate?.progress === "-" ? 0 : statsData?.click_rate?.progress}%</span>
                                                        </span>
                                                    </div>
                                                ) : (
                                                    <div className="d-flex align-items-center justify-content-start">
                                                        <h1 className="mb-1 me-2">
                                                            <Skeleton width={50} height={40} className="mb-2" highlightColor="#FB48C9" borderRadius="0.5rem" duration={4} />
                                                        </h1>
                                                        <span className="d-flex align-items-center justify-content-center">
                                                            <Skeleton width={40} height={15} className="mb-2" baseColor="#D5F5E3" highlightColor="#0CBD5B" duration={4} borderRadius="5px" />
                                                        </span>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="analytics-card analytics-card-orange me-0">
                                                <div className="d-flex align-items-center gap-1">
                                                    <div className="analytics-box"></div>
                                                    <div className="analytics-type-heading">Time on Page</div>
                                                </div>
                                                {statsData?.time_on_page?.type ? (
                                                    <div className="d-flex align-items-center justify-content-start">
                                                        <div className="analytics-count mb-1 me-1">{statsData?.time_on_page?.count}</div>
                                                        <span
                                                            className={`analytics-badge ${statsData?.time_on_page?.type === "up" ? 'analytics-badge-success' : 'analytics-badge-danger'} d-flex align-items-center justify-content-center`}
                                                        >
                                                            {statsData?.time_on_page?.type !== "-" && (
                                                                <img src={statsData?.time_on_page?.type === "up" ? analyticsUp : analyticsDown} width="10px" alt="" />
                                                            )}
                                                            <span className="ms-1">{statsData?.time_on_page?.progress === "-" ? 0 : statsData?.time_on_page?.progress}%</span>
                                                        </span>
                                                    </div>
                                                ) : (
                                                    <div className="d-flex align-items-center justify-content-start">
                                                        <h1 className="mb-1 me-2">
                                                            <Skeleton width={50} height={40} className="mb-2" highlightColor="#FB9E48" borderRadius="0.5rem" duration={4} />
                                                        </h1>
                                                        <span className="d-flex align-items-center justify-content-center">
                                                            <Skeleton width={40} height={15} className="mb-2" baseColor="#D5F5E3" highlightColor="#0CBD5B" duration={4} borderRadius="5px" />
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                            {/* <div className="analytics-card analytics-card-red me-0">
                                                <div className="d-flex align-items-center gap-1">
                                                    <div className="analytics-box"></div>
                                                    <div className="analytics-type-heading">Pages Scrolled</div>
                                                </div>
                                                {statsData?.page_scrolled?.type ? (
                                                    <div className="d-flex align-items-center justify-content-start">
                                                        <span className="analytics-count mb-1 me-1">{statsData?.page_scrolled?.count}</span>
                                                        <span
                                                            className={`analytics-badge ${statsData?.page_scrolled?.type === "up" ? 'analytics-badge-success' : 'analytics-badge-danger'} d-flex align-items-center justify-content-center`}
                                                        >
                                                            {statsData?.page_scrolled?.type !== "-" && (
                                                                <img src={statsData?.page_scrolled?.type === "up" ? analyticsUp : analyticsDown} width="10px" alt="" />
                                                            )}
                                                            <span className="ms-1">{statsData?.page_scrolled?.progress === "-" ? 0 : statsData?.page_scrolled?.progress}%</span>
                                                        </span>
                                                    </div>
                                                ) : (
                                                    <div className="d-flex align-items-center justify-content-end">
                                                        <h1 className="mb-1 me-2">
                                                            <Skeleton width={50} height={40} className="mb-2" highlightColor="#ff0000" borderRadius="0.5rem" duration={4} />
                                                        </h1>
                                                        <span className="d-flex align-items-center justify-content-center">
                                                            <Skeleton width={40} height={15} className="mb-2" baseColor="#D5F5E3" highlightColor="#0CBD5B" duration={4} borderRadius="5px" />
                                                        </span>
                                                    </div>
                                                )}
                                            </div> */}
                                        </div>

                                    </div>


                                    {data?.loaded == false ?
                                        <Skeleton height={200} className="my-2 w-full d-flex mt-4 analytics-main-chart-main mb-4"
                                            highlightColor="#ffffff"
                                            baseColor="rgba(12, 138, 247, 0.14)"
                                            borderRadius="0.5rem" duration={4} />
                                        :
                                        <div className="d-flex mt-4 analytics-main-chart-main mb-4">
                                            <Line id="analytics-main-chart"
                                                data={data} options={originalOptions}
                                                width={"100%"} height={screenWidth ? 50 : 30} />

                                        </div>
                                    }
                                </div>
                                {(statsloading) || (topSources?.length > 0 && !statsloading) ?
                                    <div className="analytics-sections mt-20px">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span>Referrers</span>
                                            <span>
                                                <CustomTooltip message={[{title:"Referrers",msg:"When a person clicks on a link to your site, the referrer information is typically recorded, allowing you to see where your traffic is coming from."},{title:"Direct",msg:"Direct traffic appears in your analytics when a visitor arrives at your site without a traceable referrer."}]}>
                                                    <img src={infoIcon} alt="" className='cursor-pointer'/>
                                                </CustomTooltip>
                                            </span>
                                        </div>

                                        {topSources && topSources.length > 0 ? (
                                            <div className="analytics-sections-items-main">
                                                {topSources.map((val, index) => (
                                                    <div className="analytics-sections-item" key={index}>
                                                        <div className="d-flex align-items-center gap-1">
                                                            <img src={val?.icon} width="18px" alt="" />
                                                            <span>{val?.source}</span>
                                                        </div>
                                                        <div className="d-flex align-items-center gap-1">
                                                            <span>{val?.count}</span>
                                                            <span className="box-ededed">{val?.percent}%</span>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <div className="analytics-sections-items-main">
                                                {[65, 45, 23, 15, 9.8].map((width, idx) => (
                                                    <div className="analytics-sections-item" key={idx}>
                                                        <div className="d-flex align-items-center gap-1">
                                                            <Skeleton
                                                                width={18}
                                                                height={18}
                                                                className="rounded-circle"
                                                                baseColor="rgba(12, 138, 247, 0.14)"
                                                                highlightColor="rgba(12, 138, 247, 0.19)"
                                                                borderRadius="50%"
                                                                duration={4}
                                                            />
                                                            <Skeleton
                                                                width={70}
                                                                height={20}
                                                                baseColor="rgba(12, 138, 247, 0.14)"
                                                                highlightColor="rgba(12, 138, 247, 0.19)"
                                                                duration={4}
                                                            />
                                                        </div>
                                                        <div className="d-flex align-items-center gap-1">
                                                            <Skeleton
                                                                width={30}
                                                                height={20}
                                                                baseColor="rgba(12, 138, 247, 0.14)"
                                                                highlightColor="rgba(12, 138, 247, 0.19)"
                                                                duration={4}
                                                            />
                                                            <Skeleton
                                                                width={30}
                                                                height={20}
                                                                className="box-ededed"
                                                                baseColor="rgba(12, 138, 247, 0.14)"
                                                                highlightColor="rgba(12, 138, 247, 0.19)"
                                                                duration={4}
                                                            />
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div> : null}
                                <div className="multiple-analytics-sections">
                                    {(statsloading) || (topCountries?.length > 0 && !statsloading) ?
                                        <div className="analytics-sections">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span>Country</span>
                                                <span>
                                                    <CustomTooltip message={[{title:"Country",msg:"The geographic location of your visitors"}]}>
                                                        <img src={infoIcon} alt="" className='cursor-pointer'/>
                                                    </CustomTooltip>
                                                </span>
                                            </div>

                                            {topCountries && topCountries.length > 0 ? (
                                                <div className="analytics-sections-items-main">
                                                    {topCountries.map((val, index) => (
                                                        <div className="analytics-sections-item analytics-progress" key={index}>
                                                            <div style={{ width: val?.percent + '%' }} className="d-flex align-items-center analytics-progress-main gap-1">
                                                                <img
                                                                    src={require(`../assets/img/flags/${val?.source}.png`)}
                                                                    width="22px"
                                                                    alt=""
                                                                />
                                                                <span>{val?.country_name}</span>
                                                            </div>
                                                            <div className="d-flex align-items-center gap-1 analytics-progress-end">
                                                                <span>{val?.count}</span>
                                                                {/* <span className="box-ededed">{val?.percent}%</span> */}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <div className="analytics-sections-items-main">
                                                    {Array(3).fill(null).map((width, idx) => (
                                                        <div key={idx} className="analytics-sections-item p-0 analytics-progress">
                                                            <div className="w-100">
                                                                <Skeleton width={"45%"} height={43}
                                                                    className="align-middle w-100"
                                                                    baseColor="rgba(12, 138, 247, 0.14)"
                                                                    highlightColor="rgba(12, 138, 247, 0.19)"
                                                                    borderRadius="0.5rem"
                                                                    duration={4}
                                                                />
                                                            </div>
                                                            <div className="analytics-progress-end">
                                                                0%
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div> : null}
                                    <div className="analytics-sections">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span>Devices</span>
                                            <span>
                                                <CustomTooltip message={[{title:"Devices",msg:"The type of device used to access your site"}]}>
                                                    <img src={infoIcon} alt="" className='cursor-pointer'/>
                                                </CustomTooltip>
                                            </span>
                                        </div>

                                        {devices && Object?.keys(devices)?.length !== 0 ?
                                            <div className="analytics-sections-items-main">


                                                <div className="analytics-sections-item analytics-progress">
                                                    <div style={{ width: devices?.desktop + '%' }} className="d-flex align-items-center analytics-progress-main gap-1">
                                                        <img src={desktopIcon} alt="" />
                                                        <span className="font-weight-500 ms-2">Desktop</span>
                                                    </div>

                                                    <div className="d-flex align-items-center gap-1 analytics-progress-end">
                                                        {devices?.desktop}%
                                                    </div>
                                                </div>
                                                <div className="analytics-sections-item analytics-progress">
                                                    <div style={{ width: devices?.mobile + '%' }} className="d-flex align-items-center analytics-progress-main gap-1">
                                                        <img src={mobileIcon} alt="" />
                                                        <span className="font-weight-500 ms-2">Mobile</span>
                                                    </div>

                                                    <div className="d-flex align-items-center gap-1 analytics-progress-end">
                                                        {devices?.mobile}%
                                                    </div>
                                                </div>
                                                <div className="analytics-sections-item analytics-progress">
                                                    <div style={{ width: devices?.tablet + '%' }} className="d-flex align-items-center analytics-progress-main gap-1">
                                                        <img src={tabletIcon} alt="" />
                                                        <span className="font-weight-500 ms-2">Tablet</span>
                                                    </div>

                                                    <div className="d-flex align-items-center gap-1 analytics-progress-end">
                                                        {devices?.tablet}%
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div className="analytics-sections-items-main">
                                                {Array(3).fill(null).map((width, idx) => (
                                                    <div key={idx} className="analytics-sections-item p-0 analytics-progress">
                                                        <div className="w-100">
                                                            <Skeleton width={"45%"} height={43}
                                                                className="align-middle w-100"
                                                                baseColor="rgba(12, 138, 247, 0.14)"
                                                                highlightColor="rgba(12, 138, 247, 0.19)"
                                                                borderRadius="0.5rem"
                                                                duration={4}
                                                            />
                                                        </div>
                                                        <div className="analytics-progress-end">
                                                            0%
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        }
                                    </div>

                                </div>

                                <div className="multiple-analytics-sections">

                                    <div className="analytics-sections">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span>Browsers</span>
                                            <span>
                                                <CustomTooltip message={[{title:"Browsers",msg:"The web browsers used by your visitors"}]}>
                                                    <img src={infoIcon} alt="" className='cursor-pointer'/>
                                                </CustomTooltip>
                                            </span>
                                        </div>
                                        {browsers &&
                                            Object.keys(browsers)?.length > 0 ?
                                            <div className="analytics-sections-items-main">
                                                <div className="analytics-sections-item analytics-progress">
                                                    <div style={{ width: browsers?.Safari + '%' }} className="d-flex align-items-center analytics-progress-main gap-1">
                                                        <img src={safariIcon} alt="" />
                                                        <span className="font-weight-500 ms-2">Safari</span>
                                                    </div>
                                                    <div className="d-flex align-items-center gap-1 analytics-progress-end">
                                                        {browsers?.Safari}%
                                                    </div>
                                                </div>
                                                <div className="analytics-sections-item analytics-progress">
                                                    <div style={{ width: browsers?.Chrome + '%' }} className="d-flex align-items-center analytics-progress-main gap-1">
                                                        <img src={chromeIcon} alt="" />
                                                        <span className="font-weight-500 ms-2">Chrome</span>
                                                    </div>
                                                    <div className="d-flex align-items-center gap-1 analytics-progress-end">
                                                        {browsers?.Chrome}%
                                                    </div>
                                                </div>
                                                <div className="analytics-sections-item analytics-progress">
                                                    <div style={{ width: browsers?.Edge + '%' }} className="d-flex align-items-center analytics-progress-main gap-1">
                                                        <img src={edgeIcon} alt="" />
                                                        <span className="font-weight-500 ms-2">Edge</span>
                                                    </div>
                                                    <div className="d-flex align-items-center gap-1 analytics-progress-end">
                                                        {browsers?.Edge}%
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div className="analytics-sections-items-main">
                                                {Array(3).fill(null).map((width, idx) => (
                                                    <div key={idx} className="analytics-sections-item p-0 analytics-progress">
                                                        <div className="w-100">
                                                            <Skeleton width={"45%"} height={43}
                                                                className="align-middle w-100"
                                                                baseColor="rgba(12, 138, 247, 0.14)"
                                                                highlightColor="rgba(12, 138, 247, 0.19)"
                                                                borderRadius="0.5rem"
                                                                duration={4}
                                                            />
                                                        </div>
                                                        <div className="analytics-progress-end">
                                                            0%
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        }
                                    </div>
                                    <div className="analytics-sections">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span>Languages</span>
                                            <span>
                                                <CustomTooltip message={[{title:"Operating System",msg:"The operating system running on visitors' devices"}]}>
                                                    <img src={infoIcon} alt="" className='cursor-pointer'/>
                                                </CustomTooltip>
                                            </span>
                                        </div>
                                        <div className="analytics-sections-items-main">
                                            {!statsloading ? (
                                                languages && Object.keys(languages)?.length > 0 ? (
                                                    Object.keys(languages).map((language, index) => (
                                                        <div className="analytics-sections-item analytics-progress" key={index}>
                                                            <div
                                                                style={{ width: `${languages[language]}%` }}
                                                                className="d-flex align-items-center analytics-progress-main gap-1"
                                                            >
                                                                <span className="font-weight-500 ms-2">{language}</span>
                                                            </div>
                                                            <div className="d-flex align-items-center gap-1 analytics-progress-end">
                                                                {languages[language]}%
                                                            </div>
                                                        </div>
                                                    ))
                                                ) : (
                                                    /* Default placeholder or empty state */
                                                    <>
                                                        {["English", "Spanish", "French"].map((language, index) => (
                                                            <div className="analytics-sections-item analytics-progress" key={index}>
                                                                <div
                                                                    style={{ width: '0%' }}
                                                                    className="d-flex align-items-center analytics-progress-main gap-1"
                                                                >
                                                                    <span className="font-weight-500 ms-2">{language}</span>
                                                                </div>
                                                                <div className="d-flex align-items-center gap-1 analytics-progress-end">
                                                                    0%
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </>
                                                )
                                            ) : (
                                                Array(3).fill(null).map((_, index) => (
                                                    <div key={index} className="analytics-sections-item p-0 analytics-progress">
                                                        <div className="w-100">
                                                            <Skeleton
                                                                width={"45%"}
                                                                height={43}
                                                                className="align-middle w-100"
                                                                baseColor="rgba(12, 138, 247, 0.14)"
                                                                highlightColor="rgba(12, 138, 247, 0.19)"
                                                                borderRadius="0.5rem"
                                                                duration={4}
                                                            />
                                                        </div>
                                                        <div className="analytics-progress-end">
                                                            0%
                                                        </div>
                                                    </div>
                                                ))
                                            )}

                                        </div>
                                    </div>

                                    {/* <div className="section-footer d-flex align-items-center justify-content-between">
                                <CommunityFooter filter={filter} setfilter={setfilter} total={activity?.paginated?.total} last_page={activity?.paginated?.last_page} current_page={activity?.paginated?.current_page}/>
                            </div> */}
                                </div>
                            </div>
                            :
                            <AnalyticsSession topCountries={topCountries} statsloading={statsloading} setactivity={setactivity} activity={activity} date={date}/>
                        }

                    </section>
                </div >
            </div >
        </>
    )
}
export default Analytics